// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ступенчатый график (StepChart) — экраны 8 и 14. */
.dl-seg {
  display: inline-flex;
  background: #f3f4f6;
  border-radius: 10px;
  padding: 3px;
  gap: 2px;
  flex: none;
}
.dl-seg button {
  border: 0;
  background: none;
  font: inherit;
  font-size: 13px;
  height: 30px;
  padding: 0 12px;
  border-radius: 8px;
  color: var(--v2-muted);
  cursor: pointer;
  white-space: nowrap;
}
.dl-seg button.is-on {
  background: #fff;
  color: var(--v2-primary);
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}

/* График */
.dl-chart {
  border-top: 1px solid var(--v2-border-soft);
  padding: 14px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.dl-chart-head {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.dl-range {
  white-space: nowrap;
}
.dl-plot {
  position: relative;
  width: 100%;
  transition: opacity 0.15s;
}
.dl-plot svg {
  display: block;
}
.dl-ax {
  font-size: 11px;
  fill: #9ca3af;
}
.dl-tip {
  position: absolute;
  top: 8px;
  width: 160px;
  background: #fff;
  border: 1px solid var(--v2-border);
  border-radius: 10px;
  padding: 8px 10px;
  font-size: 12px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  pointer-events: none;
}
.dl-tip-row {
  display: flex;
  align-items: center;
  gap: 6px;
}
.dl-tip-row i {
  width: 8px;
  height: 8px;
  border-radius: 2px;
}
.dl-tip-row b {
  margin-left: auto;
}
.dl-empty {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--v2-muted);
  font-size: 13px;
  pointer-events: none;
}
.dl-overview {
  width: 100%;
  border-radius: 8px;
  background: #f9fafb;
  cursor: grab;
  touch-action: none;
  user-select: none;
}
.dl-overview svg {
  display: block;
}
.dl-chart-foot {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.dl-series {
  height: 32px;
  padding: 0 14px;
  border-radius: 999px;
  border: 1.5px solid;
  background: #fff;
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}
.dl-quick {
  height: 30px;
  padding: 0 10px;
  border-radius: 8px;
  border: 0;
  background: #f3f4f6;
  font: inherit;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
}
.dl-quick.is-on {
  background: var(--v2-primary);
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/shared/ui/v2/stepchart.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,UAAU;AACZ;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,WAAW;AACX;EACE,2CAA2C;EAC3C,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,0CAA0C;EAC1C,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,WAAW;AACb","sourcesContent":["/* Ступенчатый график (StepChart) — экраны 8 и 14. */\n.dl-seg {\n  display: inline-flex;\n  background: #f3f4f6;\n  border-radius: 10px;\n  padding: 3px;\n  gap: 2px;\n  flex: none;\n}\n.dl-seg button {\n  border: 0;\n  background: none;\n  font: inherit;\n  font-size: 13px;\n  height: 30px;\n  padding: 0 12px;\n  border-radius: 8px;\n  color: var(--v2-muted);\n  cursor: pointer;\n  white-space: nowrap;\n}\n.dl-seg button.is-on {\n  background: #fff;\n  color: var(--v2-primary);\n  font-weight: 600;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);\n}\n\n/* График */\n.dl-chart {\n  border-top: 1px solid var(--v2-border-soft);\n  padding: 14px 16px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.dl-chart-head {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n.dl-range {\n  white-space: nowrap;\n}\n.dl-plot {\n  position: relative;\n  width: 100%;\n  transition: opacity 0.15s;\n}\n.dl-plot svg {\n  display: block;\n}\n.dl-ax {\n  font-size: 11px;\n  fill: #9ca3af;\n}\n.dl-tip {\n  position: absolute;\n  top: 8px;\n  width: 160px;\n  background: #fff;\n  border: 1px solid var(--v2-border);\n  border-radius: 10px;\n  padding: 8px 10px;\n  font-size: 12px;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);\n  pointer-events: none;\n}\n.dl-tip-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.dl-tip-row i {\n  width: 8px;\n  height: 8px;\n  border-radius: 2px;\n}\n.dl-tip-row b {\n  margin-left: auto;\n}\n.dl-empty {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--v2-muted);\n  font-size: 13px;\n  pointer-events: none;\n}\n.dl-overview {\n  width: 100%;\n  border-radius: 8px;\n  background: #f9fafb;\n  cursor: grab;\n  touch-action: none;\n  user-select: none;\n}\n.dl-overview svg {\n  display: block;\n}\n.dl-chart-foot {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.dl-series {\n  height: 32px;\n  padding: 0 14px;\n  border-radius: 999px;\n  border: 1.5px solid;\n  background: #fff;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.dl-quick {\n  height: 30px;\n  padding: 0 10px;\n  border-radius: 8px;\n  border: 0;\n  background: #f3f4f6;\n  font: inherit;\n  font-size: 13px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.dl-quick.is-on {\n  background: var(--v2-primary);\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
